import { temporarilyNotSupport } from '../../utils'

// NFC
export const stopHCE = /* @__PURE__ */ temporarilyNotSupport('stopHCE')
export const startHCE = /* @__PURE__ */ temporarilyNotSupport('startHCE')
export const sendHCEMessage = /* @__PURE__ */ temporarilyNotSupport('sendHCEMessage')
export const onHCEMessage = /* @__PURE__ */ temporarilyNotSupport('onHCEMessage')
export const offHCEMessage = /* @__PURE__ */ temporarilyNotSupport('offHCEMessage')
export const getNFCAdapter = /* @__PURE__ */ temporarilyNotSupport('getNFCAdapter')
export const getHCEState = /* @__PURE__ */ temporarilyNotSupport('getHCEState')
